const Bounce = {
  NEVER: '2',
  NEW: '1',
  UNREAD: '0',
};

export default Bounce;
